export const operatorShortNameMap = {
  'ASSAM STATE TRANSPORT CORPORATION (ASTC)': 'ASTC',
  'BIHAR STATE TOURISM DEVELOPMENT CORPORATION': 'BSTDC',
  'HIMACHAL ROAD TRANSPORT CORPORATION (HRTC)': 'HRTC',
  'PUDUCHERRY ROAD TRANSPORT CORPORATION (PRTC)': 'PRTC',
  'UTTAR PRADESH STATE ROAD TRANSPORT CORPORATION(UPSRTC)': 'UPSRTC',
  'WEST BENGAL SURFACE TRANSPORT CORPORATION': 'WBSTC',
  'RAJASTHAN STATE ROAD TRANSPORT CORPORATION': 'RSRTC'
};
